import { Datagrid, List, TextField } from "react-admin";
import { useGlobalPermission } from "../../permissions";

export const TeamList = () => (
	<List hasCreate={useGlobalPermission("teams.create")}>
		<Datagrid bulkActionButtons={false} rowClick="show">
			<TextField source="name" />
		</Datagrid>
	</List>
);
